import { Pipe, PipeTransform } from '@angular/core'
import { NotificationTypes, Notification } from '@seiri/shared/common'

// temp
const notificiationTranslations: Record<NotificationTypes, string> = {
  [NotificationTypes.ClientReservationCreated]: 'Nová rezervácia:',
  [NotificationTypes.ClientReservationCancelled]: 'Zrušená rezervácia:',
  [NotificationTypes.ClientJoinEvent]: 'Nové prihlásenie na udalosť:',
  [NotificationTypes.ClientEventCancelled]: 'Zrušená účasť na udalosti:',
  [NotificationTypes.PlanLimitPublicRefusal]: 'Prišli ste o klienta – plán je vyčerpaný:',
}

@Pipe({
  name: 'getNotificationTitle',
})
export class GetNotificationTitlePipe implements PipeTransform {
  transform(notification: Notification): string {
    if ('data' in notification && notification.data?.['type'] && typeof notification.data?.['type'] === 'string') {
      const type = notification.data['type'] as NotificationTypes
      return notificiationTranslations[type] || notification.title
    }
    return notification.title
  }
}
